import './style.css';
import * as dat from 'dat.gui';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { MeshSurfaceSampler } from 'three/examples/jsm/math/MeshSurfaceSampler.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass.js'
import { GlitchPass } from 'three/examples/jsm/postprocessing/GlitchPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader.js'
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js'




const gui = new dat.GUI();
dat.GUI.toggleHide();

// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();

const sizes = {
	width: window.innerWidth,
	height: window.innerHeight
};

window.addEventListener('resize', () => {
	// Update sizes
	sizes.width = window.innerWidth;
	sizes.height = window.innerHeight;

	// Update camera
	camera.aspect = sizes.width / sizes.height;
	camera.updateProjectionMatrix();

	// Update renderer
	renderer.setSize(sizes.width, sizes.height);
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    effectComposer.setSize(sizes.width, sizes.height)
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 1000);
camera.position.z = 30;
camera.position.y = 5;
// camera.position.x = -5;
camera.lookAt(0, 0, 0);






const group = new THREE.Group();
group.position.x = 8
group.rotation.y = - 50
scene.add(group);

const sparkles = [];
const sparklesGeometry = new THREE.BufferGeometry();
const sparklesMaterial = new THREE.ShaderMaterial({
	uniforms: {
		pointTexture: {
			value: new THREE.TextureLoader().load('./textures/particles/1.png')
		}
	},
	vertexShader: document.getElementById('vertexshader').textContent,
	fragmentShader: document.getElementById('fragmentshader').textContent,
	blending: THREE.AdditiveBlending,
	alphaTest: 1.0,
	transparent: true
});





const points = new THREE.Points(sparklesGeometry, sparklesMaterial);
// points.position.x=10
group.add(points);



let sampler = null;
const lines = [];
let linesMaterials = [
	new THREE.LineBasicMaterial({ transparent: true, color: 0x125d98 }),
	new THREE.LineBasicMaterial({ transparent: true, color: 0xcfd6de })
];
let galaxyColors = [
	new THREE.Color('#f9fbf2').multiplyScalar(0.8),
	new THREE.Color('#ffede1').multiplyScalar(0.8),
	new THREE.Color('#05c7f2').multiplyScalar(0.8),
	new THREE.Color('#0597f2').multiplyScalar(0.8),
	new THREE.Color('#0476d9').multiplyScalar(0.8)
];



function dots() {
	sampler = new MeshSurfaceSampler(model).build();

	for (let i = 0; i < 10; i++) {
		const linesMesh = new THREE.Line(new THREE.BufferGeometry(), linesMaterials[i % 2]);
		linesMesh.coordinates = [];
		linesMesh.previous = null;
		lines.push(linesMesh);
		group.add(linesMesh);
	}
	tick();

}

let model = null;
const loader = new OBJLoader();
loader.load(
	'./SurfaceSampling/derr2.obj',
	(obj) => {
		model = obj.children[0];
		model.geometry.scale(4.5, 4.5, 4.5);
		model.geometry.translate(0, -8, 0);
		model.geometry.rotateY(0.2);
		dots();
	},

);

const p1 = new THREE.Vector3();

function nextDot(line)
 {
	let ok = false;
	while (!ok)
     {
		sampler.sample(p1);
		if (line.previous && p1.distanceTo(line.previous) < 0.3) {
			line.coordinates.push(p1.x, p1.y, p1.z);
			line.previous = p1.clone();

			for (let i = 0; i < 2; i++) {
				const spark = new Sparkle();
				spark.setup(p1, line.material.color);
				sparkles.push(spark);
			}
			ok = true;
		} else if (!line.previous) {
			line.previous = p1.clone();
		}
	}
}

class Sparkle extends THREE.Vector3 
{
	setup(origin, color)
     {
		this.x = origin.x;
		this.y = origin.y;
		this.z = origin.z;
		this.v = new THREE.Vector3();
		/* X Speed */
		this.v.x = THREE.MathUtils.randFloat(0.001, 0.006);
		this.v.x *= Math.random() > 0.5 ? 1 : -1;
		/* Y Speed */
		this.v.y = THREE.MathUtils.randFloat(0.001, 0.006);
		this.v.y *= Math.random() > 0.5 ? 1 : -1;
		/* Z Speed */
		this.v.z = THREE.MathUtils.randFloat(0.001, 0.006);
		this.v.z *= Math.random() > 0.5 ? 1 : -1;

		this.size = Math.random() * 4 + 0.5 * window.devicePixelRatio;
		this.slowDown = 0.4 + Math.random() * 0.58;
		this.color = color;
	}
	update() {
		if (this.v.x > 0.001 || this.v.y > 0.001 || this.v.z > 0.001) {
			this.add(this.v);
			this.v.multiplyScalar(this.slowDown);
		}
	}
}

class Star {
	setup(color) {
		this.r = Math.random() * 12 + 3;
		this.phi = Math.random() * Math.PI * 2;
		this.theta = Math.random() * Math.PI;
		this.v = new THREE.Vector2().random().subScalar(0.5).multiplyScalar(0.0007);

		this.x = this.r * Math.sin(this.phi) * Math.sin(this.theta);
		this.y = this.r * Math.cos(this.phi);
		this.z = this.r * Math.sin(this.phi) * Math.cos(this.theta);

		this.size = Math.random() * 4 + 0.5 * window.devicePixelRatio;
		this.color = color;
	}
	update() {
		this.phi += this.v.x;
		this.theta += this.v.y;
		this.x = this.r * Math.sin(this.phi) * Math.sin(this.theta);
		this.y = this.r * Math.cos(this.phi);
		this.z = this.r * Math.sin(this.phi) * Math.cos(this.theta);
	}
}

const stars = [];
const galaxyGeometryVertices = [];
const galaxyGeometryColors = [];
const galaxyGeometrySizes = [];

for (let i = 0; i < 1000; i++) {
	const star = new Star();
	star.setup(galaxyColors[Math.floor(Math.random() * galaxyColors.length)]);
	galaxyGeometryVertices.push(star.x, star.y, star.z);
	galaxyGeometryColors.push(star.color.r, star.color.g, star.color.b);
	galaxyGeometrySizes.push(star.size);
	stars.push(star);
}




const starsGeometry = new THREE.BufferGeometry();
starsGeometry.setAttribute('size', new THREE.Float32BufferAttribute(galaxyGeometrySizes, 1));
starsGeometry.setAttribute('color', new THREE.Float32BufferAttribute(galaxyGeometryColors, 3));
const galaxyPoints = new THREE.Points(starsGeometry, sparklesMaterial);
galaxyPoints.position.x=10
scene.add(galaxyPoints);

let _prev = 0;

function updateSparklesGeometry() {
	let tempSparklesArraySizes = [];
	let tempSparklesArrayColors = [];
	sparkles.forEach((s) => {
		tempSparklesArraySizes.push(s.size);
		tempSparklesArrayColors.push(s.color.r, s.color.g, s.color.b);
	});
	sparklesGeometry.setAttribute('color', new THREE.Float32BufferAttribute(tempSparklesArrayColors, 3));
	sparklesGeometry.setAttribute('size', new THREE.Float32BufferAttribute(tempSparklesArraySizes, 1));
}

// Controls
// const controls = new OrbitControls(camera, canvas);
// controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
	canvas: canvas
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

// renderer.toneMapping = THREE.ReinhardToneMapping
/**
 * Animate
 */



const effectComposer = new EffectComposer(renderer);
effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
effectComposer.setSize(sizes.width, sizes.height);

const renderPass = new RenderPass(scene, camera);
effectComposer.addPass(renderPass);

const unrealBloomPass = new UnrealBloomPass();
unrealBloomPass.enabled = true;
unrealBloomPass.strength = 1.5;
unrealBloomPass.exposure = 1;
unrealBloomPass.radius = 0.9;
unrealBloomPass.threshold = 0.0;
effectComposer.addPass(unrealBloomPass);




gui.add(unrealBloomPass, 'enabled');
gui.add(unrealBloomPass, 'strength').min(0).max(4).step(0.001);
gui.add(unrealBloomPass, 'radius').min(0).max(3).step(0.001);
gui.add(unrealBloomPass, 'threshold').min(0).max(1).step(0.001);



let cursor ={
	x:0,
	y:0
}

let targetx =0
let targety =0

window.addEventListener('mousemove', (event)=>{
	cursor.x = (event.clientX - (sizes.width/2))
	cursor.y =  (event.clientY - (sizes.height/2))


} )





const clock = new THREE.Clock();

const tick = (a) => {
	const elapsedTime = clock.getElapsedTime();

	group.rotation.y +=( 0.0015)
	targetx = cursor.x * .001;
	targety = cursor.y * .001;
	console.log(targetx,targety)
	if(group)
	{
		
		group.rotation.x +=( 0.15 * ( targetx - group.rotation.x*5 ));

	}


	// Update controls
	// controls.update();

	// Render
	// renderer.render(scene, camera)
	if (a - _prev > 10) {
		lines.forEach((l) => {
			if (sparkles.length < 32000) {
				nextDot(l);
				nextDot(l);
			}
			const tempVertices = new Float32Array(l.coordinates);
			l.geometry.setAttribute('position', new THREE.BufferAttribute(tempVertices, 3));
			l.geometry.computeBoundingSphere();
		});
		updateSparklesGeometry();
		_prev = a;
	}

	let tempSparklesArray = [];
	sparkles.forEach((s) => {
		s.update();
		tempSparklesArray.push(s.x, s.y, s.z);
	});

	sparklesGeometry.setAttribute('position', new THREE.Float32BufferAttribute(tempSparklesArray, 3));

	let tempStarsArray = [];
	stars.forEach((s) => {
		s.update();
		tempStarsArray.push(s.x, s.y, s.z);
	});

	starsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(tempStarsArray, 3));

	effectComposer.render();

	// Call tick again on the next frame
	window.requestAnimationFrame(tick);
};

tick();
